/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps, useNavigateAction } from "./utils";
import { Badge, Button, Flex, Text, View } from "@aws-amplify/ui-react";
export default function TestCard(props) {
  const { test, overrides, ...rest } = props;
  const buttonOnClick = useNavigateAction({
    type: "url",
    url: `${"quiz/"}${test?.id}`,
  });
  return (
    <View
      width="402px"
      height="238px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      borderRadius="7px"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "TestCard")}
      {...rest}
    >
      <Flex
        gap="16px"
        direction="column"
        width="406px"
        height="219px"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
        position="absolute"
        top="calc(50% - 109.5px - -9.5px)"
        left="calc(50% - 203px - 2px)"
        padding="16px 16px 16px 16px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "TestCard48541689")}
      >
        <Flex
          gap="133px"
          direction="row"
          width="unset"
          height="34px"
          justifyContent="space-between"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="5px 25px 5px 25px"
          {...getOverrideProps(overrides, "FrameLabels")}
        >
          <Badge
            width="unset"
            height="unset"
            gap="0"
            shrink="0"
            size="small"
            variation="success"
            children={test?.durationInMinutes}
            {...getOverrideProps(overrides, "Badge Type")}
          ></Badge>
          <Badge
            width="unset"
            height="unset"
            gap="0"
            padding="6px 3px 6px 3px"
            shrink="0"
            size="small"
            variation="success"
            children={test?.numberOfQuestions}
            {...getOverrideProps(overrides, "Badge Level")}
          ></Badge>
          <Badge
            width="unset"
            height="unset"
            gap="0"
            justifyContent="flex-start"
            overflow="hidden"
            shrink="0"
            size="small"
            variation="success"
            children={test?.Grade}
            {...getOverrideProps(overrides, "Badge Number Questions")}
          ></Badge>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="70px"
          justifyContent="space-between"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="6px 7px 6px 7px"
          {...getOverrideProps(overrides, "Frame Test Card")}
        >
          <Flex
            gap="0"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="7px 5px 7px 5px"
            {...getOverrideProps(overrides, "Test Title")}
          >
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="700"
              color="rgba(13,26,38,1)"
              lineHeight="20px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={test?.Topic}
              {...getOverrideProps(overrides, "Topic")}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(48,64,80,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={test?.name}
              {...getOverrideProps(overrides, "Test Name")}
            ></Text>
          </Flex>
          <Flex
            gap="2px"
            direction="column"
            width="75px"
            height="44px"
            justifyContent="flex-start"
            alignItems="flex-end"
            shrink="0"
            position="relative"
            padding="6px 6px 6px 6px"
            {...getOverrideProps(overrides, "Frame 148541700")}
          >
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="800"
              color="rgba(13,26,38,1)"
              lineHeight="20px"
              textAlign="right"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="duration:"
              {...getOverrideProps(overrides, "duration Label")}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="800"
              color="rgba(13,26,38,1)"
              lineHeight="20px"
              textAlign="right"
              display="block"
              direction="column"
              justifyContent="unset"
              width="60px"
              height="22px"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={test?.durationInMinutes}
              {...getOverrideProps(overrides, "duration")}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="10px"
          direction="row"
          width="252px"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="8px 13px 8px 13px"
          {...getOverrideProps(overrides, "Frame 148521671")}
        >
          <Button
            width="unset"
            height="48px"
            grow="1"
            shrink="1"
            basis="0"
            size="large"
            isDisabled={false}
            variation="primary"
            children={test?.Type == "PRACTICE" ? "Go Practice" : "Go Test"}
            onClick={() => {
              buttonOnClick();
            }}
            {...getOverrideProps(overrides, "Button")}
          ></Button>
        </Flex>
      </Flex>
    </View>
  );
}
